import { Component, OnInit } from '@angular/core';
import { ReportsService } from 'app/shared/services/reports.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'timezone-component',
  templateUrl: './timezone.component.html',
  styleUrls: ['./timezone.component.scss'],
})
export class TimezoneComponent implements OnInit {
  public selectedTimezone: string;

  constructor(
    public reportsService: ReportsService,
    public modalsService: ModalsService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {}

  ngOnInit() {
    let timezoneDropdown: HTMLElement;
    this.selectedTimezone = this.reportsService.selectedTimezone.name;
    setTimeout(() => {
      timezoneDropdown = document.getElementById('timezoneDropdown');
      if (timezoneDropdown) {
        timezoneDropdown.focus();
      }
    }, 400);
  }

  confirm() {
    this.reportsService.setTimezone(this.selectedTimezone);
    this.modalsService.hideModal();
  }

  cancel() {
    this.modalsService.hideModal();
  }
}
